// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__rVXG4","head":"ProcedureTableInfo_head__2XiQx"};